export type AppView = "positions" | "build";

type Props = {
  readonly value: AppView;
  readonly onChange: (v: AppView) => void;
};

const OPTIONS: ReadonlyArray<{ id: AppView; label: string }> = [
  { id: "build", label: "New position" },
  { id: "positions", label: "My Positions" },
];

/**
 * Primary, page-level navigation between the positions overview and the
 * builder. Sits above the card and supersedes the old in-card Open/Close
 * toggle — close/modify are now reached via buttons on a position.
 */
export const ViewSwitch = ({ value, onChange }: Props) => (
  <div
    role="radiogroup"
    aria-label="View"
    className="flex items-center gap-0.5 p-0.5 rounded-[var(--radius-sm)]"
    style={{ border: "1px solid var(--line-2)" }}
  >
    {OPTIONS.map((opt) => {
      const active = value === opt.id;
      return (
        <button
          key={opt.id}
          role="radio"
          aria-checked={active}
          type="button"
          onClick={() => onChange(opt.id)}
          className="flex-1 text-center px-4 h-8 rounded-[2px] font-mono text-[11px] tracking-[0.16em] uppercase whitespace-nowrap transition-colors"
          style={{
            background: active ? "var(--surface-2)" : "transparent",
            color: active ? "var(--ink-1)" : "var(--ink-3)",
            fontWeight: 500,
          }}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);
